module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/visa-mc-88-25-0b893f80e8e21715151bff032d263f2e.png";